var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg9D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5986 9.64C31.5053 9.64 33.2119 10.0867 34.7186 10.98C36.2386 11.8733 37.4386 13.12 38.3186 14.72C39.1986 16.3067 39.6386 18.1467 39.6386 20.24V28.6C39.6386 30.8667 39.1986 32.8267 38.3186 34.48C37.4386 36.12 36.1986 37.3867 34.5986 38.28C32.9986 39.16 31.1186 39.6 28.9586 39.6C27.5586 39.6 26.2253 39.3933 24.9586 38.98C23.7053 38.5533 22.5453 37.8533 21.4786 36.88L25.3586 33C25.8386 33.48 26.3919 33.8533 27.0186 34.12C27.6586 34.3867 28.3053 34.52 28.9586 34.52C29.9986 34.52 30.8986 34.28 31.6586 33.8C32.4319 33.3067 33.0253 32.6733 33.4386 31.9C33.8653 31.1133 34.0786 30.28 34.0786 29.4V25.12L34.9986 26.12C34.1853 26.96 33.2319 27.6067 32.1386 28.06C31.0453 28.5 29.9186 28.72 28.7586 28.72C26.9453 28.72 25.3453 28.3133 23.9586 27.5C22.5853 26.6867 21.5053 25.5733 20.7186 24.16C19.9453 22.7467 19.5586 21.1333 19.5586 19.32C19.5586 17.5067 20.0186 15.8733 20.9386 14.42C21.8586 12.9533 23.0786 11.7933 24.5986 10.94C26.1186 10.0733 27.7853 9.64 29.5986 9.64ZM29.5986 14.84C28.7719 14.84 28.0119 15.04 27.3186 15.44C26.6386 15.84 26.0919 16.38 25.6786 17.06C25.2786 17.74 25.0786 18.4933 25.0786 19.32C25.0786 20.1467 25.2786 20.9067 25.6786 21.6C26.0786 22.28 26.6186 22.8267 27.2986 23.24C27.9786 23.64 28.7319 23.84 29.5586 23.84C30.3853 23.84 31.1386 23.64 31.8186 23.24C32.5119 22.8267 33.0586 22.28 33.4586 21.6C33.8719 20.9067 34.0786 20.1467 34.0786 19.32C34.0786 18.52 33.8786 17.78 33.4786 17.1C33.0786 16.42 32.5386 15.8733 31.8586 15.46C31.1786 15.0467 30.4253 14.84 29.5986 14.84Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.75 60C42.8745 60 30 72.8745 30 75.75C30 72.8745 17.1255 60 14.25 60C17.1255 60 30 47.1255 30 44.25C30 47.1255 42.8745 60 45.75 60Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9D);
export default __webpack_public_path__ + "static/media/9d.81559cfd1b7101a19ba5dfcf7a4e46b2.svg";
export { ForwardRef as ReactComponent };